exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wepay-wrapper {\n  max-width: 800px;\n  padding: 10px 1px 0 0;\n  margin: 0 auto !important; }\n\n@media screen and (max-width: 663px) {\n  .wepay-wrapper {\n    max-width: 300px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Payments/PaymentCollection/components/PaymentForm/collectionForm.scss
// module id = 1346
// module chunks = 1